import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import { Label } from "../ui/label";
import { Alert, AlertDescription } from "../ui/alert";
import { CheckCircle, AlertCircle } from "lucide-react";
import API_CONSTRUCTOR from "../../models/api-model";

/**
 * Confirm Payment Dialog
 * Allows admin to confirm inspection payment for a query
 */
export const ConfirmPaymentDialog = ({ queryId, onClose, onConfirmed }) => {
  const [notes, setNotes] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  
  // Initialize API
  const api = API_CONSTRUCTOR();

  const handleConfirm = async () => {
    try {
      setLoading(true);
      setError(null);

      await api.put(`/queries/${queryId}/confirm-inspection`, {
        notes: notes,
      });

      setSuccess(true);
      setTimeout(() => {
        onConfirmed();
      }, 1500);
    } catch (err) {
      console.error("Error confirming payment:", err);
      setError(err.response?.data?.error || "Failed to confirm payment");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={true} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Confirm Inspection Payment</DialogTitle>
          <DialogDescription>
            Confirm that the $150 inspection payment has been received from the homeowner.
          </DialogDescription>
        </DialogHeader>

        {success ? (
          <div className="py-6">
            <Alert className="border-green-200 bg-green-50">
              <CheckCircle className="h-4 w-4 text-green-600" />
              <AlertDescription className="text-green-800">
                Payment confirmed successfully!
              </AlertDescription>
            </Alert>
          </div>
        ) : (
          <>
            <div className="space-y-4 py-4">
              <div className="space-y-2">
                <Label htmlFor="payment-notes">Payment Notes (Optional)</Label>
                <Textarea
                  id="payment-notes"
                  placeholder="Add any notes about the payment..."
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                  rows={4}
                />
              </div>

              {error && (
                <Alert variant="destructive">
                  <AlertCircle className="h-4 w-4" />
                  <AlertDescription>{error}</AlertDescription>
                </Alert>
              )}
            </div>

            <DialogFooter>
              <Button variant="outline" onClick={onClose} disabled={loading}>
                Cancel
              </Button>
              <Button onClick={handleConfirm} disabled={loading}>
                {loading ? "Confirming..." : "Confirm Payment"}
              </Button>
            </DialogFooter>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmPaymentDialog;

